import useLocalization from 'localization';
import { useMemo } from 'react';
import useToggle from './useToggle';
const useLinkProps = (to, child) => {
    const [isHovered, handleMouseEnter, handleMouseLeave] = useToggle();
    const [isFocused, handleFocus, handleBlur] = useToggle();
    const { t } = useLocalization();
    const isExternal = to.toString().includes('://');
    const children = useMemo(() => {
        if (typeof child === 'string') {
            return t(String(child));
        }
        return child;
    }, [child]);
    return useMemo(() => ({
        isHovered,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        isFocused,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children,
        ...(isExternal ? { href: to.toString(), target: '_blank' } : { to: to.toString() })
    }), [
        isFocused,
        handleFocus,
        handleBlur,
        isHovered,
        handleMouseEnter,
        handleMouseLeave,
        to,
        isExternal,
        child
    ]);
};
export default useLinkProps;
//# sourceMappingURL=useLinkProps.js.map